import { render, staticRenderFns } from "./importTips.vue?vue&type=template&id=0141e0ab&scoped=true&"
import script from "./importTips.vue?vue&type=script&lang=js&"
export * from "./importTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0141e0ab",
  null
  
)

export default component.exports